var _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.49957,
    cy: 9.99958,
    rx: 6.0025,
    ry: 2.50104,
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5021 13.5005C15.5021 14.8818 12.8147 16.0015 9.49957 16.0015C6.18448 16.0015 3.49707 14.8818 3.49707 13.5005",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5045 9.99902C21.5045 11.3803 18.817 12.5001 15.502 12.5001",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5021 9.99902V17.5021C15.5021 18.8834 12.8147 20.0032 9.49957 20.0032C6.18448 20.0032 3.49707 18.8834 3.49707 17.5021V9.99902",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5045 6.49805V14.0012C21.5045 15.3825 18.817 16.5022 15.502 16.5022",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99923 7.50853C9.70224 7.2536 9.52168 6.88886 9.49902 6.49811C9.49902 5.11754 12.1901 3.99707 15.5015 3.99707C18.8129 3.99707 21.504 5.11754 21.504 6.49811C21.504 7.87869 18.8129 8.99915 15.5015 8.99915C15.3315 8.99915 15.1614 8.99915 15.0013 8.98915",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallets);
export default __webpack_public_path__ + "static/media/wallets.a0248e9cb7ced34e82e63564b5644c1c.svg";
export { ForwardRef as ReactComponent };